import { makeStyles } from "@material-ui/core/styles";

/**
 * Shared reject popup styling hook to reduce duplication across reject popup components.
 * Provides common styles for reject popup layout, table structure, and form elements.
 *
 * @returns {Object} Object containing Material-UI classes
 */
const useRejectPopupStyles = makeStyles(theme => ({
  title: {
    marginTop: theme.spacing(0),
  },
  tableContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  headerRow: {
    paddingTop: "0.4rem",
    paddingBottom: "0.8rem",
    borderBottom: "solid 1px #e7e7e7",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  productRow: {
    paddingTop: "0.8rem",
    paddingBottom: "0.8rem",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderBottom: "solid 1px #e7e7e7",
  },
  headerText: {
    color: theme.palette.text.disabled,
    ...theme.typography.button,
    textTransform: "none",
  },
  name: {
    color: theme.palette.text.primary,
    ...theme.typography.body1,
    textTransform: "none",
    marginBottom: theme.spacing(1),
  },
  valueText: {
    color: theme.palette.text.primary,
    ...theme.typography.button,
    textTransform: "none",
  },
  address: {
    color: theme.palette.text.disabled,
    ...theme.typography.button,
    textTransform: "none",
  },
  divider: {
    height: "2px",
  },
  secondaryTitle: {
    ...theme.typography.subtitle2,
    color: theme.palette.text.disabled,
    marginBottom: theme.spacing(1),
  },
  rejectReason: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
  },
  additionalInfo: {
    marginBottom: theme.spacing(4),
  },
  radioButtonGroup: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginTop: theme.spacing(2),
  },
  radioButton: {
    color: theme.palette.secondary.main,
  },
  radioButtonLabel: {
    ...theme.typography.button,
    textTransform: "none",
  },
  input: {
    height: "5px",
  },
}));

export default useRejectPopupStyles;
